import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, TextField, Button, Typography, Box, IconButton, Tooltip } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { Slide, toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../../components/Header";
import BASE_URL from "../../config/apiConfig";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import "./AdminStyles.css";

const Admin = () => {
    const [notifyRows, setNotifyRows] = useState([]);
    const [originalNotify, setOriginalNotify] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        document.title = "Admin";
        fetchNotifyList();
    }, []);

    const fetchNotifyList = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/admin/notify`, { withCredentials: true });
            setOriginalNotify(res.data);
            setNotifyRows(res.data);
        } catch (err) {
            toast.error("Failed to load Notify table");
        } finally {
            setLoading(false);
        }
    };

    const handleEmailsChange = (id, value) => {
        setNotifyRows(prev =>
            prev.map(row =>
                row.NotifyId === id ? { ...row, Emails: value } : row
            )
        );
    };

    const saveNotify = async () => {
        const changedRows = notifyRows.filter((row, index) => row.Emails !== originalNotify[index].Emails);

        if (changedRows.length === 0) {
            return;
        }

        try {
            for (const row of changedRows) {
                await axios.post(`${BASE_URL}/api/admin/notify`,{
                    NotifyId: row.NotifyId,
                    Emails: row.Emails
                }, { withCredentials: true });
            }
            toast.success("Emails list updated.");
            setOriginalNotify(notifyRows);
        } catch (err) {
            toast.error("Error saving updates.");
        }
    };

    return (
        <>
            <Header />
            <div className="adminContainer">
                <Box sx={{ pt: "1rem", pb: "4rem" }}>
                    <h1 className="adminTitle">Admin</h1>
                    <div className="adminFields">
                        <Box className="adminField" component={Paper} p={2} my={2} sx={{ boxShadow: "none", border: "1px solid #ccc" }}>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography
                                    sx={{
                                        position: "relative",
                                        fontSize: "15px",
                                        fontWeight: 600,
                                        color: "#1f1f1f",
                                        backgroundColor: "#fff",
                                        top: -33,
                                        left: -8,
                                        px: 0.5,
                                    }}
                                >
                                    Notifications
                                </Typography>
                                <Button
                                    variant="outlined"
                                    startIcon={<SaveIcon />}
                                    onClick={saveNotify}
                                >
                                    Save
                                </Button>
                            </Box>

                            {loading ? (
                                <div>
                                    <div className="loader center">
                                        <i className="fa fa-cog fa-spin"/>
                                    </div>
                                </div>
                            ) : (
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ width: "64px", padding: "4px 16px", fontSize: "14px" }}>ID</TableCell>
                                            <TableCell sx={{ width: "288px", padding: "4px 16px", fontSize: "14px" }}>Notification</TableCell>
                                            <TableCell sx={{ padding: "4px 16px", fontSize: "14px" }}>
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <div style={{ marginRight: 4 }}>
                                                        Emails
                                                    </div>
                                                    <Tooltip placement="right" title="Emails should be a semicolon separated list of email recipients.">
                                                        <IconButton size="small" aria-label="info">
                                                            <InfoOutlinedIcon fontSize="small" style={{ cursor: "pointer" }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {notifyRows.map((row) => (
                                            <TableRow key={row.NotifyId}>
                                                <TableCell sx={{ padding: "4px 16px", fontSize: "14px" }}>{row.NotifyId}</TableCell>
                                                <TableCell sx={{ padding: "4px 16px", fontSize: "14px" }}>{row.Notification}</TableCell>
                                                <TableCell sx={{ padding: "4px 16px", fontSize: "14px" }}>
                                                    <TextField
                                                        variant="standard"
                                                        InputLabelProps={{ sx: { fontSize: "14px" } }}
                                                        fullWidth
                                                        value={row.Emails || ""}
                                                        onChange={(e) => handleEmailsChange(row.NotifyId, e.target.value)}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            )}
                        </Box>
                    </div>
                </Box>
            </div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Slide}
            />
        </>
    );
}

export default Admin;
